// public API
export { AgmSnazzyInfoWindowModule } from './snazzy-info-window.module';
export { AgmSnazzyInfoWindow } from './directives/snazzy-info-window';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/snazzy-info-window/index.js
// module id = ./node_modules/@agm/snazzy-info-window/index.js
// module chunks = 5